// Launch-price anchor for the pricing page (Billing #2 conversion - PR-C1).
//
// HONESTY (SPEC §5 H2/H4): `regular` is the price Pro will revert to AFTER the
// launch window. It MUST be a genuine prior/intended regular price - NOT an
// invented number - and must stay in sync with `subscription_plans` / the
// public site before merge. Live launch prices are $19.90/mo and $199/yr.
// Confirm the `regular` figures with product before shipping.
export const LAUNCH_ANCHOR = {
  pro_monthly: { regular: 29.9, note: 'launch' }, // shown struck-through vs live $19.90
  pro_yearly: { regular: 299.0, note: 'launch' }, // vs live $199
} as const;

export type LaunchAnchorCode = keyof typeof LAUNCH_ANCHOR;

/** Resolve the launch anchor for a plan `code`, or null when none applies. */
export function getLaunchAnchor(
  code: string | undefined
): { regular: number; note: string } | null {
  if (!code) return null;
  return (LAUNCH_ANCHOR as Record<string, { regular: number; note: string }>)[code] ?? null;
}
